<template>
  <!--arrows-padding-->
  <vueper-slides v-if="items.length"
                 ref="slider"
                 class="no-shadow"
                 :class="arrowsOutside ? 'arrows-padding' : ''"
                 fixed-height="125px"
                 :arrows-outside="!arrowsOutside"
                 :arrows="true"
                 bullets-outside
                 :touchable="false"
                 :visible-slides="itemsPerSlide"
                 :gap="10"
                 :dot-size="18"
                 disableArrowsOnEdges
                 :slide-ratio="0.7"
                 slideMultiple
                 :breakpoints="{ 800: { visibleSlides: 3, slideMultiple: 3 } }">

    <template v-slot:arrow-left>
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
    </template>

    <template v-slot:arrow-right>
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
    </template>

    <!--<vueper-slide class="selector__slide"-->
                  <!--:class="!selectedDress ? 'selected' : ''"-->
                  <!--@click.native="resetDress()"-->
                  <!--image="/img/modelli-none.jpg"></vueper-slide>-->

    <vueper-slide class="selector__slide"
                  :class="selectedDress && selectedDress === item  ? 'selected' : ''"
                  v-for="(item,i) in items"
                  :key="item.id" :title="'0'+(i+1)"
                  :image="item.image"
                  @click.native="setDress(item,i)" />
  </vueper-slides>
</template>

<script>
  import { VueperSlides, VueperSlide } from 'vueperslides'

  import { mapActions } from 'vuex';
  import { mapGetters } from 'vuex';

  export default {
    name: "DressCarousel",
    components: {
      VueperSlide,
      VueperSlides
    },
    props: {
      items: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        itemsPerSlide: 3,
        vilibleSlide: 3,
        // selectedDress: null,
      }
    },
    computed: {
      ...mapGetters('mannequin',[
        'poser',
      ]),
      ...mapGetters('clothes',[
        'selectedClothes',
        'selectedDress',
        'selectedDressInClothes',
        'defaultTopDress',
        'defaultBottomDress'
      ]),
      arrowsOutside: function() {
        return this.items.length > this.vilibleSlide;
      },
    },
    methods: {
      ...mapActions('clothes',[
        'wearDress',
        'unwearDress',
      ]),
      ...mapActions([
        'render'
      ]),
      setDress(item,i) {

        // console.log(this.poser);
        // console.log(item);
        this.wearDress(item).then( () => {
          // console.log('in component render');
          this.render();
          this.$refs.slider && this.$refs.slider.goToSlide(i);
        });

      }
    },
    mounted() {
      // console.log(this.items);

      this.vilibleSlide = this.items.length > this.itemsPerSlide ? this.itemsPerSlide : this.items.length;
      // console.log(this.selectedDress);
      // if(!this.selectedDress)
        // this.selectedDress = this.selectedDressInClothes(this.items) ? this.selectedDressInClothes(this.items).inst : null;

      //vado alla slide del carosello se ho gia un elemento selezionato
      let i = this.items.indexOf(this.selectedDress);
      if(i) {
        this.$refs.slider && this.$refs.slider.goToSlide(i);
      }

      // console.log(this.selectedDress);
    }
  }
</script>

<style scoped>


</style>